import { FORM_KEYS } from './../../edit-service.service';
import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { EditServiceService } from '../../edit-service.service';
import * as moment from 'moment';
import { GetValuesService } from 'src/app/core/services/get-values.service';

@Component({
  selector: 'app-resume-info-step',
  templateUrl: './resume-info-step.component.html',
  styleUrls: ['./resume-info-step.component.scss']
})
export class ResumeInfoStepComponent {

  FORM_KEYS = FORM_KEYS;

  formattedStartDate: string = '';
  formattedEndDate: string = '';

  pickupContactSamePerson: boolean = false;



  @Input() ServiceForm: FormGroup | null | undefined = undefined;
  @Input() LoadingSimulation: boolean = false;

  constructor(private EditServiceService: EditServiceService, private getValuesService: GetValuesService) { }

  ngOnInit() {
    this.formattedStartDate = this.parseDate(this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.StartDate])?.value);
    this.formattedEndDate = this.parseDate(this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.EndDate])?.value);
    this.pickupContactSamePerson = this.areContactsEqual()
  }

  parseDate(date: string | null): string {
    if (!date) return '';

    return moment(date, 'DD-MM-YYYY HH:mm')
      .locale('es')
      .format('D MMMM, YYYY');
  }

  areContactsEqual(): boolean {
    const origin = this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact])?.value;
    const destination = this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact])?.value;

    if (!origin || !destination) {
      return false;
    }

    return Object.keys(origin).every(
      key => origin[key] === destination[key]
    );
  }

  getServiceType(id?: number): string {
    if (!id) return 'Desconocido';
    return this.getValuesService.getServiceTypeString(id);
  }


  get originAddressValue(): string {
    return this.ServiceForm?.get([FORM_KEYS.AddressData, FORM_KEYS.OriginAddress, FORM_KEYS.Address])?.value ?? '';
  }

  get originContactName(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.Name])?.value ?? '';
  }

  get originContactLastName(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.LastName])?.value ?? '';
  }

  get originContactPhoneNumber(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.PhoneNumber])?.value ?? '';
  }

  get originContactEmail(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.Email])?.value ?? '';
  }

  get originContactIsContactParticular(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.IsContactParticular])?.value ?? '';
  }




  get destinationAddressValue(): string {
    return this.ServiceForm?.get([FORM_KEYS.AddressData, FORM_KEYS.DestinationAddress, FORM_KEYS.Address])?.value ?? '';
  }

  get destinationContactName(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.Name])?.value ?? '';
  }

  get destinationContactLastName(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.LastName])?.value ?? '';
  }

  get destinationContactPhoneNumber(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.PhoneNumber])?.value ?? '';
  }

  get destinationContactEmail(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.Email])?.value ?? '';
  }

  get destinationContactIsContactParticular(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.IsContactParticular])?.value ?? '';
  }





  get commetsServiceForm(): string {
    return this.ServiceForm?.get([FORM_KEYS.DayContactData, FORM_KEYS.Comments])?.value ?? '';
  }


  get Products(): FormArray {
    return this.ServiceForm?.get([FORM_KEYS.ProductData, FORM_KEYS.Products]) as FormArray;
  }

  get Fees(): FormArray {
    return this.ServiceForm?.get([FORM_KEYS.ProductData, FORM_KEYS.Fees]) as FormArray;
  }


  get TaxPercentageValue(): number {
    return this.ServiceForm?.get([FORM_KEYS.ProductData, FORM_KEYS.TaxPercentage])?.value ?? '';
  }

  get TotalOrderAmountValue(): number {
    return this.ServiceForm?.get([FORM_KEYS.ProductData, FORM_KEYS.TotalOrderAmount])?.value ?? '';
  }

  get TotalOrderTaxAmountValue(): number {
    return this.ServiceForm?.get([FORM_KEYS.ProductData, FORM_KEYS.TotalOrderTaxAmount])?.value ?? '';
  }



}
